import axios from 'axios'
import Vue from 'vue'
import AppUser from '../classes/appUser'

export default {
  namespaced: true,

  state: {
    user: null,
    token: null
  },

  mutations: {
    token_set(state, token) {
      if (token != null) {
        // REMOVED: state.auth.token = token; // This line was causing the error
        state.token = token
      }
    },
    // записать токен в хранилище
    token_store(state, token) {
      if (token != null) {
        sessionStorage.setItem('token', token)
        state.token = token
        // REMOVED: state.auth.token = token; // This line was causing the error
      }
    },
    // сброс и удаление токена
    token_reset(state) {
      state.token = null
      // REMOVED: state.auth.token = null; // This line was causing the error
      sessionStorage.removeItem('token')
    },

    // установка пользователя
    user_set(state, user) {
      state.user = user
      Vue.prototype.$currentUser = new AppUser(user)
    },

    // сброс пользователя
    user_reset(state) {
      state.user = null
      localStorage.removeItem('login');
      localStorage.removeItem('password');
      Vue.prototype.$currentUser = null
    }
  },

  actions: {
    // установить токен и сохранить его в хранилище
    setToken({ commit }, token) {
      commit('token_set', token)
      commit('token_store', token)
    },

    // восстановление токена из хранилища
    restoreToken({ commit }) {
      const token = sessionStorage.getItem('token')
      commit('token_set', token)
    },

    async validateAuthToken({ commit }, { login, password, authCode }) {
      try {
        const response = await axios.post('/auth/validateauthtoken', {
          login,
          password,
          authCode
        });

        const token = response.data.token;

        if (token) {
          commit('token_set', token);
          // Store in sessionStorage for persistence
          sessionStorage.setItem('token', token);
          return { success: true, token };
        } else {
          throw new Error('No token received');
        }
      } catch (error) {
        console.error('Authentication error:', error);
        throw error;
      }
    },

    // вход в систему - получение токена / аутентификация
    // eslint-disable-next-line no-unused-vars
    async login({ commit }, { login, password }) {
      try {
        const response = await axios.post('/auth/login', { login, password });

        const token = response.data.token;

        if (token) {
          commit('token_set', token);
          // Store in sessionStorage for persistence
          sessionStorage.setItem('token', token);
          return { success: true, token };
        }
      } catch (error) {
        console.error('Authentication error:', error);
        throw error;
      }
    },

    // получение данных пользователя
    async setUser({ dispatch, commit }) {
      // загрузка пользователе-зависимых данных
      await dispatch('cargoTypes/init', null, { root: true })
      // настройки
      await dispatch('settings/init', null, { root: true })

      const response = await axios.get('/auth/CurrentUser')
      commit('user_set', response.data)
    },

    // выход из системы
    logout({ dispatch, commit }) {
      // сброс пользователе-зависимых данных
      dispatch('cargoTypes/reset', null, { root: true })
      // настройки
      dispatch('settings/reset', null, { root: true })

      commit('token_reset')
      commit('user_reset')
    }
  }
}